import type { ComponentChildren } from 'preact';
import { useState } from 'preact/hooks';
import { Icon, type IconName } from './Icon';

interface Props {
  title: string;
  icon?: IconName;
  subtitle?: string;
  complete?: boolean;
  defaultOpen?: boolean;
  actions?: ComponentChildren;
  children: ComponentChildren;
}

export function CollapsibleSection({
  title,
  icon,
  subtitle,
  complete = false,
  defaultOpen = true,
  actions,
  children,
}: Props) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section class="section">
      <button
        type="button"
        class={`section__header ${open ? 'section__header--open' : ''}`}
        onClick={() => setOpen((o) => !o)}
      >
        <span class="section__title">
          {icon ? <Icon name={icon} /> : null}
          {title}
          {!open && subtitle ? <span class="section__subtitle">({subtitle})</span> : null}
          {complete ? <Icon name="check-badge" size={18} /> : null}
        </span>
        <span class="section__actions">
          {open ? actions : null}
          <Icon name="chevron" rotate={open ? 180 : 0} />
        </span>
      </button>
      {open ? (
        <>
          <div class="section__divider" />
          <div class="section__body">{children}</div>
        </>
      ) : null}
    </section>
  );
}
